"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuthSettings = /** @class */ (function () {
    function AuthSettings() {
    }
    AuthSettings.OAUTH_SERVICE_TOKEN_ENDPOINT = '/oauth/token';
    AuthSettings.OAUTH_SERVICE_CHECK_TOKEN_ENDPOINT = '/oauth/check_token';
    AuthSettings.LOGIN_ENDPOINT = '/login';
    AuthSettings.IS_SAML_USER = 'is_saml_user';
    AuthSettings.OAUTH_SERVICE_USERDATA_ENDPOINT = '/me';
    AuthSettings.OAUTH_SERVICE_LOGOUT_ENDPOINT = '/logout';
    AuthSettings.CLIENT_ID = 'client';
    AuthSettings.CLIENT_SECRET = 'secret';
    AuthSettings.OAUTH_SERVICE_URL_KEY = 'oauth-service-url';
    AuthSettings.TOKEN_KEY_NAME = 'access_token';
    AuthSettings.USERNAME_KEY_NAME = 'username';
    AuthSettings.CSRF_TOKEN_KEY_NAME = 'csrfToken';
    AuthSettings.GUEST_USER_NAME = 'Guest';
    AuthSettings.GUEST_PASSWORD = '123456';
    AuthSettings.GUEST_USER_ID = -3;
    AuthSettings.VERIFY_CODE = '/verifycode';
    AuthSettings.RESEND = '/resend';
    return AuthSettings;
}());
exports.AuthSettings = AuthSettings;
//# sourceMappingURL=auth-settings.config.js.map